import { Injectable } from "@angular/core";
import { ThermalApi } from "../thermal-api";

@Injectable()
export class ConfigApi {

    constructor(
        private thermalApi: ThermalApi,
    ) {

    }

    setMaskConfig(pass: any, isMaskOpen: any = '1', isVoiceOpen: any = '1') {
        const method: string = 'POST';
        const func: string = 'setMaskConfig';
        const params = new FormData();
        params.append('pass', pass);
        params.append('isMaskOpen', isMaskOpen);
        params.append('isVoiceOpen', isVoiceOpen);
        params.append('voiceContext', '');
        return this.thermalApi.request(method, null, func, params);
    }

    setTemperatureConfig(pass: any, errorTemperature: any = '37.3', isTemperatureOpen: any = '1') {
        const method: string = 'POST';
        const func: string = 'setTemperatureConfig';
        const params = new FormData();
        params.append('pass', pass);
        params.append('isTemperatureOpen', isTemperatureOpen);
        params.append('errorTemperature', errorTemperature);
        params.append('voiceContext', '');
        return this.thermalApi.request(method, null, func, params);
    }

    setConfig(pass: any, companyName: string, saveIdentifyTime: number = 10) {
        const method: string = 'POST';
        const func: string = 'setConfig';
        const params = new FormData();
        params.append('pass', pass);
        params.append('config', JSON.stringify({ saveIdentifyTime: saveIdentifyTime, companyName: companyName }));
        return this.thermalApi.request(method, null, func, params);
    }

    changeLogo(pass: any, imgBase64: string) {
        const method: string = 'POST';
        const func: string = 'changeLogo';
        const params = new FormData();
        params.append('pass', pass);
        params.append('imgBase64', imgBase64);
        return this.thermalApi.request(method, null, func, params);
    }


}


// WEBPACK FOOTER //
// ./src/shared/thermal/services/config.api.ts